module.exports = __webpack_public_path__ + "static/img/brand-first-2.b5034a22.png";